import {Component, store, constant} from 'Generic';
import {
  numberFormat,
  getTranslation,
  removeAddon,
  calculateDiscountedAmountAndPercentage,
  calculateTotalOldPrice,
  addCurrencySymbol,
  showCouponResponcse,
  isTrialPlan,
  getPhasePlanDescription,
  isAddonCart,
} from 'Generic/lib';

export default class OrderSummary extends Component {
  constructor() {
    super({
      store,
      state: store.state,
    });
  }

  render() {
    const selectedPlan = this.state.selected_plan ? this.state.selected_plan : {};
    const currencyCode = this.state.currency_code ? this.state.currency_code : 'USD';
    const selectedAddons = this.state.selected_addons ? this.state.selected_addons : [];
    const coupon = this.state.coupon_code || '';
    const adjustment = selectedPlan.adjustment ? {amount: -parseFloat(selectedPlan.adjustment)} : {amount: 0};
    const userCountry = this.state.user_country && this.state.show_vat !== '0' ? this.state.user_country : '';

    this.calculateRecurlyPricing(selectedPlan, currencyCode, selectedAddons, coupon, userCountry, adjustment);
  }

  async calculateRecurlyPricing(selectedPlan, currencyCode, selectedAddons, coupon, userCountry, adjustment) {
    const checkoutPricing = recurly.Pricing.Checkout();
    const checkoutSubscription = recurly.Pricing.Subscription();
    await checkoutSubscription.plan(this.state?.proplan_code || selectedPlan.code);
    for (const addon of selectedAddons) {
      await checkoutSubscription.addon(addon).done();
    }

    checkoutPricing
      .adjustment(adjustment)
      .currency(currencyCode)
      .tax({country: userCountry})
      .subscription(checkoutSubscription)
      .catch(err => {
        // err.code
        console.log(err);
      })
      .done(price => {
        checkoutPricing
          .coupon(coupon)
          .catch(err => {
            showCouponResponcse(false);
          })
          .done(price => {
            /* if coupon applied */
            let couponApplied = false;
            if (this.state.coupon_code && checkoutPricing.couponCodes.length) {
              showCouponResponcse(true);
              couponApplied = this.state.coupon_code;
            }

            this.updateOrderSummary(price, selectedPlan, currencyCode, couponApplied);
          });
      });
  }

  updateOrderSummary(totalPriceObject, selectedPlan, currencyCode, couponApplied = false) {
    let {addons, months} = selectedPlan;
    let monthlyOldPrices = this.state.old_prices ? this.state.old_prices : {};

    months = parseInt(this.state.count_extra_month) === 1 ? months : selectedPlan.interval_length;
    let sumRequiredAddonPrice = calculateTotalOldPrice(months, monthlyOldPrices, currencyCode, selectedPlan);

    this.updateTotalPrice(totalPriceObject);
    this.updatePlanSummary(selectedPlan, sumRequiredAddonPrice, totalPriceObject);
    // this.updateRequiredAddonSummary(addons);
    this.updateAddonSummary(addons);
    this.updateCouponSummary(couponApplied);
    this.updateDiscountSummary(sumRequiredAddonPrice, totalPriceObject);
    this.updateTrialDescription(selectedPlan);
    this.updateVat(totalPriceObject);
  }

  updatePlanSummary(planObject, oldPrice, totalPriceObject) {
    const {setup_fee: setupFee, per_month: perMonthPrice, months, labels} = planObject;
    const {adjustments: adjustments, items: subscriptionItems} = totalPriceObject.now;
    let [{plan: planPrice}] = subscriptionItems;
    planPrice = Number(planPrice) + Number(adjustments);

    const paymentPlanElement = document.querySelector('.payment-plan');
    const planNameElement = document.querySelector('.payment-plan .plan-name');
    const freePlanHeadingElement = document.querySelector('.free-plan-summary');
    const planSummaryElement = document.querySelector('.plan-summary .addon-description');
    const planOrigPriceElement = document.querySelector('.plan-summary .plan-orig-price');

    if (isAddonCart()) {
      paymentPlanElement.style.display = 'none';
      return;
    } else {
      paymentPlanElement.style.display = '';
    }

    let couponCodeValue = document.querySelector('.coupon-code-dynamic-value');
    if (couponCodeValue) {
      couponCodeValue.innerHTML = labels.coupon_code_label ? labels.coupon_code_label : '';
    }

    planNameElement.innerHTML = this.getPlanTitle(planObject);
    freePlanHeadingElement.innerHTML =
      labels && labels.order_summary_second_label
        ? `<div class='clearfix'><span class="pull-left">${labels.order_summary_second_label}</span><span class="pull-right">${addCurrencySymbol(
            '0.00',
          )}</span></div>`
        : '';

    planSummaryElement.innerHTML = `${getTranslation(planObject.billing_cycle)} (${addCurrencySymbol(numberFormat(perMonthPrice))}/mo) ${
      labels && labels.extra_months_label ? labels.extra_months_label : ''
    }`;
    planOrigPriceElement.innerHTML = months + ' x ' + addCurrencySymbol(perMonthPrice);
  }

  updateAddonSummary(planAddons) {
    const planObject = this.state.selected_plan;
    const proplanPackages = this.state.proplan_packages;
    const specialAddonList = constant.specialAddonList;
    const selectedPRoplanPkg = proplanPackages?.[planObject.code]?.[this.state?.proplan_index];

    let addons = (this.state?.proplan_code && selectedPRoplanPkg?.labels?.product_info?.addons) || planAddons;
    const selectedAddons = this.state.selected_addons ? this.state.selected_addons : [];

    let addonSummaryElement = document.querySelector('.addons-summary');
    let addonSummary = '';
    addonSummary = selectedAddons.reduce((previousValue, currentValue) => {
      let addon = addons.find(addon => {
        return addon.code == currentValue;
      });

      if (addon) {
        if (!specialAddonList.includes(addon.code)) {
          let addonPrice = Number(addon.unit_amount) / Number(planObject.interval_length);
          let addonCountry = constant.addonsCountryList[currentValue] ? constant.addonsCountryList[currentValue] : [];
          addonCountry = addonCountry.find(addonCountry => addonCountry.code == this.state.addon_country);

          return (
            previousValue +
            `<div class='clearfix'><span class="pull-left">${addon.name} (${addCurrencySymbol(numberFormat(addonPrice))}/mo) ${
              addonCountry ? `- ` + addonCountry.name : ''
            }</span>
              <span class="pull-right">${addCurrencySymbol(numberFormat(addon.unit_amount))}</span></div>`
          );
        }
      } else {
        removeAddon(currentValue);
      }

      return previousValue;
    }, '');
    addonSummaryElement.innerHTML = addonSummary;
  }

  updateCouponSummary(couponApplied) {
    let couponSummary = '';
    let couponSummaryElement = document.querySelector('.coupon-summary');
    let couponHide = this.state.coupon_hide ? this.state.coupon_hide : false;

    if (couponApplied) {
      if (couponHide) couponSummary = `<div class="payment-plan"><span class="pull-left">Coupon applied</span></div>`;
      else couponSummary = `<div class="payment-plan"><span class="pull-left">Coupon applied - ${couponApplied}</span></div>`;
    }

    couponSummaryElement.innerHTML = couponSummary;
  }

  updateDiscountSummary(oldPrice, totalPriceObject) {
    const {subtotal: subTotal, adjustments: adjustments, items: subscriptionItems} = totalPriceObject.now;
    let [{plan: planPrice}] = subscriptionItems;
    planPrice = Number(planPrice) + Number(adjustments);

    let discountSummaryElement = document.querySelector('.discount-summary');
    let discountSummary = '';
    let [discountPercentage, discountAmount] = calculateDiscountedAmountAndPercentage(Number(oldPrice), planPrice);

    if (!isAddonCart() && !isTrialPlan() && Number(discountAmount) > 0) {
      discountSummary = `<span id="discount-label">${getTranslation('save')} ${discountPercentage}%</span>`;
    }

    discountSummaryElement.innerHTML = discountSummary;
  }

  updateTotalPrice(price) {
    let planTotalPriceElement = document.querySelector('#payment_total');
    if (planTotalPriceElement) {
      let taxAmount = '0.00';
      let totalPrice = '0';

      const adjustments = price.now.adjustments;
      const subTotal = price.now.subtotal;

      // custom calculation if adjustment exit
      // beacuse recurly calculating tax before appyling prediscount
      if (price && price.taxes.length && adjustments !== '0.00') {
        taxAmount = Number(price.taxes[0].rate) * subTotal;
        totalPrice = Number(subTotal) + Number(taxAmount);
      } else {
        totalPrice = price.now.total;
      }

      window.total_price = totalPrice;
      planTotalPriceElement.innerHTML = addCurrencySymbol(numberFormat(totalPrice));
    }
  }

  updateTrialDescription(planObject) {
    let trialDescriptionElement = document.querySelector('.trial-description-text');
    let trialDescriptionText = planObject.labels?.trial_description_label;
    let trialDescription = '';

    if (isTrialPlan() && trialDescriptionText) trialDescription = this.formatTrialText(planObject, trialDescriptionText);

    trialDescriptionElement.innerHTML = trialDescription;
  }

  updateVat(price) {
    const gatewayTaxSummary = document.querySelector('.tax-summary');
    if (gatewayTaxSummary) {
      let taxPercentageElement = gatewayTaxSummary.querySelector('.text-percentage');
      let taxAmountElement = gatewayTaxSummary.querySelector('.pull-right');
      let taxPercentage = '0';
      let taxAmount = '0.00';

      const subTotal = price.now.subtotal;

      if (price && price.taxes.length) {
        taxAmount = Number(price.taxes[0].rate) * subTotal;
        taxPercentage = Number(price.taxes[0].rate) * 100;
      }

      taxPercentageElement.innerHTML = taxPercentage;
      taxAmountElement.innerHTML = addCurrencySymbol(numberFormat(taxAmount));
    }
  }

  formatTrialText(planObject, text) {
    const {unit_amount: unitAmount, interval_length: intervalLength, interval_unit: intervalUnit, trial_length: trialLength} = planObject;
    var trialExpiryDate = new Date(new Date().getTime() + trialLength * 24 * 60 * 60 * 1000);

    return text
      .replace(/%price%/g, `${addCurrencySymbol(unitAmount)}`)
      .replace(/%billingcycle%/g, `${this.getMonthIntervalText(intervalUnit, intervalLength)}`)
      .replace(
        /%date%/g,
        trialExpiryDate.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        }),
      );
  }

  getPlanTitle(planObject) {
    let {
      interval_length: intervalLength,
      interval_unit: intervalUnit,
      trial_length: trialLength,
      trial_unit: trialUnit,
      display_additional_months: displayAdditionalMonths,
      display_months: displayMonths,
      labels,
    } = planObject;

    /* If order summary first label is available */
    if (labels && labels.order_summary_first_label) return labels.order_summary_first_label;

    /* If trial plan */
    if (isTrialPlan()) {
      const {labels} = planObject;
      return labels.package_plan_label;
    }

    /* If phase plan */
    let phasePlanDecription = getPhasePlanDescription(planObject);
    if (phasePlanDecription) {
      const {phase_interval_unit, phase_interval_length} = phasePlanDecription;
      intervalUnit = phase_interval_unit;
      intervalLength = phase_interval_length;
    }

    /* If additional months */
    // if (displayAdditionalMonths && displayAdditionalMonths > 0 && displayMonths) {
    //   let display_additional_months_text = displayAdditionalMonths > 1 ? getTranslation('months') : getTranslation('month');

    //   return `${this.getMonthIntervalText(intervalUnit, displayMonths)} + ${displayAdditionalMonths} ${display_additional_months_text}`;
    // }

    return labels && labels.package_plan_label ? labels.package_plan_label : planObject.name;
  }

  getMonthIntervalText(intervalUnit, intervalLength) {
    switch (intervalUnit) {
      case 'days':
        return intervalLength > 1 ? `${intervalLength} ${getTranslation('Days')}` : `${intervalLength} ${getTranslation('Day')}`;
      case 'months':
        return intervalLength > 1 ? `${intervalLength} ${getTranslation('Months')}` : `${intervalLength} ${getTranslation('Month')}`;
      case 'years':
        return intervalLength > 1 ? `${intervalLength} ${getTranslation('Years')}` : `${intervalLength} ${getTranslation('Year')}`;
    }
  }
}
